// extracted by mini-css-extract-plugin
export var contentBody = "_7a-9";
export var headerImage = "_7a-2";
export var imageButton = "_7a-7";
export var imageButtonIcon = "_7a-8";
export var imageHeader = "_7a-4";
export var imageHeaderText = "_7a-5";
export var imageOverlay = "_7a-3";
export var imageTitle = "_7a-6";
export var imageWrapper = "_7a-1";
export var taskList = "_7a-a";
export var widget = "_7a-0";